export const CONFCAM_DONE = 'confcam done';
export const UERESET_DONE = "uereset succ"; // RESET of Engine has been done
export const HEROLVL_DONE = "herolvl done"; // LOADING of bike has been done
export const ENVIRONMENT_DONE = "envilvl done"; // ENVIRONMENT switch done 
export const INTROGO_COMMAND = "introgo 1";
export const INTROIN_COMMNAD = "introin 1";
export const PORTRMD_COMMAND = "portrmd "; 
export const TOUCHMD_COMMAND = "touchmd "; 